(function() {
    function readConfig() {
        var element = document.getElementById('hm-runtime-config');
        var text = '';

        if (!element) {
            return {};
        }

        text = element.content ? element.content.textContent : element.textContent;

        if (!text) {
            return {};
        }

        try {
            return JSON.parse(text);
        } catch (error) {
            return {};
        }
    }

    function getCookie(name) {
        var value = name + '=';
        var cookies = decodeURIComponent(document.cookie).split(';');

        for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i];

            while (cookie.charAt(0) === ' ') {
                cookie = cookie.substring(1);
            }

            if (cookie.indexOf(value) === 0) {
                return cookie.substring(value.length, cookie.length);
            }
        }

        return '';
    }

    function afterPageSettled(callback) {
        if (typeof callback !== 'function') {
            return;
        }

        var run = function() {
            setTimeout(callback, 5000);
        };

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', run, {once: true});
            return;
        }

        run();
    }

    function onReady(callback) {
        if (typeof callback !== 'function') {
            return;
        }

        if (window.jQuery) {
            window.jQuery(callback);
            return;
        }

        window.hmReadyQueue.push(callback);
    }

    function afterFirstInteraction(callback) {
        if (typeof callback !== 'function') {
            return;
        }

        if (firstInteractionDone) {
            callback();
            return;
        }

        firstInteractionCallbacks.push(callback);

        if (firstInteractionListening) {
            return;
        }

        firstInteractionListening = true;
        firstInteractionEvents.forEach(function(eventName) {
            window.addEventListener(eventName, runFirstInteractionCallbacks, true);
        });
    }

    function runFirstInteractionCallbacks() {
        if (firstInteractionDone) {
            return;
        }

        firstInteractionDone = true;

        firstInteractionEvents.forEach(function(eventName) {
            window.removeEventListener(eventName, runFirstInteractionCallbacks, true);
        });

        while (firstInteractionCallbacks.length) {
            firstInteractionCallbacks.shift()();
        }
    }

    function loadAssetStyle(href, callback) {
        if (!href) {
            return;
        }

        var selector = 'link[href="' + href.replace(/"/g, '\\"') + '"]';
        var existing = document.querySelector(selector);

        if (existing) {
            existing.rel = 'stylesheet';
            existing.media = existing.getAttribute('data-hm-media') || existing.media || 'all';

            if (callback) {
                if (existing.sheet || existing.getAttribute('data-loaded') === '1') {
                    callback();
                } else {
                    existing.addEventListener('load', callback, {once: true});
                }
            }
            return;
        }

        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = href;
        link.addEventListener('load', function() {
            link.setAttribute('data-loaded', '1');
            if (callback) {
                callback();
            }
        });
        document.head.appendChild(link);
    }

    function loadAssetScript(src, callback) {
        if (!src) {
            return;
        }

        var selector = 'script[src="' + src.replace(/"/g, '\\"') + '"]';
        var existing = document.querySelector(selector);

        if (existing) {
            if (callback) {
                if (existing.getAttribute('data-loaded') === '1') {
                    callback();
                } else {
                    existing.addEventListener('load', callback, {once: true});
                }
            }
            return;
        }

        var script = document.createElement('script');
        script.src = src;
        script.async = true;
        script.addEventListener('load', function() {
            script.setAttribute('data-loaded', '1');
            if (callback) {
                callback();
            }
        });
        document.head.appendChild(script);
    }

    function loadBootstrap(callback) {
        if (window.bootstrap) {
            if (callback) {
                callback();
            }
            return;
        }

        loadAssetScript(window.hmAssets && window.hmAssets.bootstrap, callback);
    }

    function loadSweetAlert(callback) {
        if (window.swal) {
            if (callback) {
                callback();
            }
            return;
        }

        loadAssetScript(window.hmAssets && window.hmAssets.sweetAlert, callback);
    }

    function loadShopScript(callback) {
        if (window.hmShopScriptLoaded) {
            if (callback) {
                callback();
            }
            return;
        }

        loadAssetScript(window.hmAssets && window.hmAssets.shop, function() {
            window.hmShopScriptLoaded = true;
            if (callback) {
                callback();
            }
        });
    }

    function afterCookieConsentLoaded(openSettings) {
        if (openSettings && window.cookieConsent && typeof window.cookieConsent.showSettings === 'function') {
            window.cookieConsent.showSettings(0);
        }
    }

    function loadCookieConsent(openSettings) {
        if (typeof window.hmRunCookieConsent !== 'function') {
            return;
        }

        window.hmRunCookieConsent();
        afterCookieConsentLoaded(openSettings);
    }

    function bindCookieConsent() {
        var cookieName = 'cc_cookie_' + document.domain;
        var hasConsentCookie = getCookie(cookieName) !== '';

        if (!hasConsentCookie) {
            afterPageSettled(function() {
                loadCookieConsent(false);
            });
        }

        document.addEventListener('click', function(event) {
            var target = event.target;
            var button = target && target.closest ? target.closest('.cookie-button') : null;

            if (!button) {
                return;
            }

            event.preventDefault();
            loadCookieConsent(true);
        }, true);
    }

    function initTooltip(target, show) {
        if (!target) {
            return;
        }

        if (!window.bootstrap || !window.bootstrap.Tooltip) {
            if (show) {
                loadBootstrap(function() {
                    initTooltip(target, show);
                });
            }
            return;
        }

        var tooltip = window.bootstrap.Tooltip.getInstance ? window.bootstrap.Tooltip.getInstance(target) : null;
        if (!tooltip) {
            tooltip = new window.bootstrap.Tooltip(target);
        }

        if (show && tooltip && typeof tooltip.show === 'function') {
            tooltip.show();
        }
    }

    function bindTooltips() {
        document.addEventListener('mouseover', function(event) {
            var target = event.target && event.target.closest ? event.target.closest('[data-bs-toggle="tooltip"]') : null;
            initTooltip(target, true);
        }, true);

        document.addEventListener('focusin', function(event) {
            var target = event.target && event.target.closest ? event.target.closest('[data-bs-toggle="tooltip"]') : null;
            initTooltip(target, true);
        }, true);
    }

    function activateAsyncStyles() {
        var links = document.querySelectorAll('link[data-hm-async-style]');

        for (var i = 0; i < links.length; i++) {
            var link = links[i];
            link.rel = 'stylesheet';
            link.media = link.getAttribute('data-hm-media') || 'all';
        }
    }

    function loadSmartsupp() {
        if (!tracking.smartsuppKey || window.hmSmartsuppLoaded) {
            return;
        }

        window.hmSmartsuppLoaded = true;
        window._smartsupp = window._smartsupp || {};
        window._smartsupp.key = tracking.smartsuppKey;

        (function(d) {
            var s = d.getElementsByTagName('script')[0];
            var c = d.createElement('script');
            var o = window.smartsupp = function() {
                o._.push(arguments);
            };

            o._ = [];
            c.type = 'text/javascript';
            c.charset = 'utf-8';
            c.async = true;
            c.src = 'https://www.smartsuppchat.com/loader.js?';
            s.parentNode.insertBefore(c, s);
        })(document);
    }

    function loadFacebook() {
        if (window.hmFacebookLoaded) {
            return;
        }

        window.hmFacebookLoaded = true;

        if (tracking.facebookPixelId) {
            !function(f, b, e, v, n, t, s) {
                if (f.fbq) {
                    return;
                }
                n = f.fbq = function() {
                    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
                };
                if (!f._fbq) {
                    f._fbq = n;
                }
                n.push = n;
                n.loaded = true;
                n.version = '2.0';
                n.queue = [];
                t = b.createElement(e);
                t.async = true;
                t.src = v;
                s = b.getElementsByTagName(e)[0];
                s.parentNode.insertBefore(t, s);
            }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
            window.fbq('init', tracking.facebookPixelId);
            window.fbq('track', 'PageView');
        }

        if (tracking.facebookChat) {
            (function(d, s, id) {
                var js;
                var fjs = d.getElementsByTagName(s)[0];

                if (d.getElementById(id)) {
                    return;
                }

                js = d.createElement(s);
                js.id = id;
                js.src = 'https://connect.facebook.net/sk_SK/sdk/xfbml.customerchat.js#xfbml=1&version=v6.0&autoLogAppEvents=1';
                fjs.parentNode.insertBefore(js, fjs);
            }(document, 'script', 'facebook-jssdk'));
        }
    }

    function loadSeznam() {
        if (!tracking.seznamId) {
            return;
        }

        function hit() {
            if (window.rc && window.rc.retargetingHit) {
                window.rc.retargetingHit({rtgId: tracking.seznamId});
            }
        }

        if (window.rc && window.rc.retargetingHit) {
            hit();
            return;
        }

        loadAssetScript('https://c.seznam.cz/js/rc.js', hit);
    }

    function applyStoredConsent() {
        var cookie = {};
        var rawCookie = getCookie('cc_cookie_' + document.domain);

        if (!rawCookie) {
            return;
        }

        try {
            cookie = JSON.parse(rawCookie);
        } catch (error) {
            cookie = {};
        }

        if (!cookie || !cookie.level) {
            return;
        }

        if (cookie.level.indexOf('marketing') === -1) {
            window.gtag('consent', 'default', {
                ad_storage: 'denied',
                ad_user_data: 'denied',
                ad_personalization: 'denied'
            });
        } else {
            afterPageSettled(loadFacebook);
            window.gtag('consent', 'default', {
                ad_storage: 'granted',
                ad_user_data: 'granted',
                ad_personalization: 'granted'
            });
        }

        if (cookie.level.indexOf('analytics') === -1) {
            window.gtag('consent', 'default', {
                analytics_storage: 'denied'
            });
        } else {
            afterPageSettled(loadSeznam);
            afterPageSettled(loadSmartsupp);
            window.gtag('consent', 'default', {
                analytics_storage: 'granted'
            });
        }
    }

    function watchGoogleMaps() {
        var src = features.googleMapsSrc;

        if (!src) {
            return;
        }

        window.initMap = window.initMap || Function();

        onReady(function() {
            var loaded = false;

            function loadGoogleMaps() {
                if (loaded) {
                    return;
                }

                loaded = true;
                loadAssetScript(src);
            }

            function watch() {
                var map = document.getElementById('google-map');

                if (!map) {
                    return;
                }

                if ('IntersectionObserver' in window) {
                    var observer = new IntersectionObserver(function(entries) {
                        entries.forEach(function(entry) {
                            if (entry.isIntersecting) {
                                observer.disconnect();
                                loadGoogleMaps();
                            }
                        });
                    }, {rootMargin: '700px 0px'});

                    observer.observe(map);
                    return;
                }

                window.addEventListener('scroll', loadGoogleMaps, {once: true, passive: true});
                window.addEventListener('mousemove', loadGoogleMaps, {once: true, passive: true});
                window.addEventListener('touchstart', loadGoogleMaps, {once: true, passive: true});
            }

            watch();
        });
    }

    function showLanguageModal() {
        onReady(function() {
            var modal = document.querySelector('[data-hm-show-language-modal]');

            if (!modal) {
                return;
            }

            var show = function() {
                if (window.bootstrap && window.bootstrap.Modal) {
                    window.bootstrap.Modal.getOrCreateInstance(modal).show();
                    return;
                }

                if (window.jQuery && window.jQuery.fn && window.jQuery.fn.modal) {
                    window.jQuery(modal).modal('show');
                }
            };

            afterFirstInteraction(function() {
                loadBootstrap(show);
            });
        });
    }

    function bindSearchAutocompleteHelp() {
        var show = function(input) {
            var form;
            var autocompleteBox;
            var autocompleteHelp;
            var resultLists;
            var i;

            if (!input || !input.matches || !input.matches('.minisearch input[name="q"]') || input.value.length >= 3) {
                return;
            }

            form = input.closest('.minisearch');
            autocompleteBox = form ? form.querySelector('.autocomplete') : null;
            autocompleteHelp = autocompleteBox ? autocompleteBox.querySelector('.autocomplete-help') : null;

            if (!autocompleteBox || !autocompleteHelp) {
                return;
            }

            autocompleteBox.style.display = 'block';
            autocompleteHelp.style.display = 'block';
            resultLists = autocompleteBox.querySelectorAll('.ui-autocomplete:not(.autocomplete-help)');

            for (i = 0; i < resultLists.length; i++) {
                resultLists[i].style.display = 'none';
            }
        };

        document.addEventListener('focus', function(event) {
            show(event.target);
        }, true);

        document.addEventListener('focusin', function(event) {
            show(event.target);
        });

        document.addEventListener('pointerdown', function(event) {
            var target = event.target;
            var boxes;
            var i;

            if (target && target.matches && target.matches('.minisearch input[name="q"]')) {
                show(target);
                return;
            }

            if (target && target.closest && target.closest('.minisearch')) {
                return;
            }

            boxes = document.querySelectorAll('.minisearch .autocomplete');

            for (i = 0; i < boxes.length; i++) {
                boxes[i].style.display = 'none';
            }
        });
    }

    var config = readConfig();
    var app = config.app || {};
    var tracking = config.tracking || {};
    var features = config.features || {};
    var firstInteractionCallbacks = [];
    var firstInteractionListening = false;
    var firstInteractionDone = false;
    var firstInteractionEvents = ['pointerdown', 'mousedown', 'touchstart', 'keydown'];

    window.hmRuntimeConfig = config;
    window.hmReadyQueue = window.hmReadyQueue || [];
    window.hmReady = window.hmReady || onReady;
    window.hmAfterPageSettled = window.hmAfterPageSettled || afterPageSettled;
    window.hmAfterFirstInteraction = window.hmAfterFirstInteraction || afterFirstInteraction;
    window.hmLoadAssetStyle = window.hmLoadAssetStyle || loadAssetStyle;
    window.hmLoadAssetScript = window.hmLoadAssetScript || loadAssetScript;
    window.hmLoadBootstrap = window.hmLoadBootstrap || loadBootstrap;
    window.hmLoadSweetAlert = window.hmLoadSweetAlert || loadSweetAlert;
    window.hmLoadShopScript = window.hmLoadShopScript || loadShopScript;
    window.hmAfterCookieConsentLoaded = window.hmAfterCookieConsentLoaded || afterCookieConsentLoaded;
    window.hmLoadCookieConsent = window.hmLoadCookieConsent || loadCookieConsent;
    window.getCookie = window.getCookie || getCookie;
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function() {
        window.dataLayer.push(arguments);
    };

    window.dataLayer.push({event: 'gtm.init_consent'});
    window.dataLayer.push({event: 'gtm.init'});

    window.ajax_url = app.ajaxUrl || window.ajax_url;
    window.privacy_url = app.privacyUrl || window.privacy_url;
    window.contact_url = app.contactUrl || window.contact_url;
    window.lang = app.lang || window.lang || {};
    window.currency = app.currency || window.currency;
    window.currency_rate = app.currencyRate || window.currency_rate || 1;
    window.shop_country = app.shopCountry || window.shop_country || 'sk';
    window.development = app.development === true;
    window.wholesale = app.wholesale === true;
    window.hmAssets = config.assets || window.hmAssets || {};
    window.facebook = window.facebook || loadFacebook;
    window.seznam = window.seznam || loadSeznam;
    window.smartsupp = window.smartsupp || loadSmartsupp;

    activateAsyncStyles();
    applyStoredConsent();
    bindTooltips();
    bindCookieConsent();
    bindSearchAutocompleteHelp();
    watchGoogleMaps();
    showLanguageModal();
})();
